// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FZKA","col":"styles_col__2EbQS"};